import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Snow.css';

export default function Snow() {
  const { settings, setSettings } = React.useContext(AppContext);
  const { snow } = settings;
  function changeSnow() {
    setSettings({ ...settings, snow: !snow });
  }

  return (
    <div
      onClick={changeSnow}
      className={`App-tree__snow ${settings.snow ? 'active' : ''}`}
      style={{
        backgroundImage: `url(./assets/svg/snow.svg)`,
      }}
    />
  );
}
